import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import { Image, Button } from "semantic-ui-react"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { BASIC } from "../../../v1/constants/membershipPanel"
import UpdateMembershipImg from "../../../images/dashboard/update-membership.svg"
import MembershipUpgradeModal2_0 from "../../../v2/components/Membership2.0/MembershipUpgradeModal"
import {
  maxPercentDiscountDiff,
  nextMembershipUpgrades
} from "../../../v1/helpers/membershipHelpers"

class UpgradeMembershipCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      membershipModalOpen: false
    }
  }
  toggleMembershipUpgradeModal = () => {
    this.setState({ membershipModalOpen: !this.state.membershipModalOpen })
  }
  render() {
    const { t, user, accountTierName, nextUpgrades } = this.props
    const { membershipModalOpen } = this.state
    const { membership } = user
    const percentDiscount = maxPercentDiscountDiff(membership, nextUpgrades)
    return (
      <>
        {accountTierName === BASIC && (
          <div className="upgrade-membership-card">
            <div className="upgrade-membership-card-section">
              <p className="upgrade-membership-card-header">{`${t("saveAdditionalLbl")} ${parseInt(
                percentDiscount
              )}%`}</p>
              <p className="upgrade-membership-card-text">{t("onMaintenanceAndRepairText")}</p>
              <Button
                className="updrade-membership-button"
                size="tiny"
                content={t("upgradeMembershipText")}
                onClick={this.toggleMembershipUpgradeModal}
              />
            </div>
            <div>
              <Image className="upgrade-membership-card-image" src={UpdateMembershipImg} />
            </div>
          </div>
        )}
        {membershipModalOpen && (
          <MembershipUpgradeModal2_0
            isOpen={membershipModalOpen}
            closeModal={this.toggleMembershipUpgradeModal}
            variableContentType="settingsSection"
            showUpgradeBenefits={true}
          />
        )}
      </>
    )
  }
}

function mapStateToProps(state) {
  let user = state.user || {}
  const membershipData = state.membershipData || {}
  return {
    user,
    accountTierName: user.membership && user.membership.plan_name,
    nextUpgrades: nextMembershipUpgrades(user, membershipData.availableMembershipPlans)
  }
}
export default withRouter(
  connect(mapStateToProps)(withTranslation("browseServices")(UpgradeMembershipCard))
)
